import React from "react";
import { SettingRow } from "../SettingRow";
import { Text } from "../../../../../../common/components/input/Text";

interface ConsentBannerUSTextRowProps {
  formApi: { change: (field: string, value: string) => void };
  informationalBannerDefaultText: string;
}

export const ConsentBannerUSTextRow = ({
  formApi,
  informationalBannerDefaultText,
}: ConsentBannerUSTextRowProps) => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title="Informational Banner Text"
      helpText="This is the text that will show on the informational Privacy Notice banner."
    >
      <Text
        className="w-100 mb-sm"
        fullWidth={false}
        field="informationalBannerText"
        multiline
        rows={6}
        variant="outlined"
        helperText=""
        required
      />
      <div className="mb-md">
        <a
          onClick={(e) => {
            e.preventDefault();
            formApi.change("informationalBannerText", informationalBannerDefaultText);
          }}
          href="#"
        >
          Set to Default Text
        </a>
      </div>
    </SettingRow>
  );
};
